import { PageTypes } from "Types/enums";
import { PageTemplateProps } from "Types/PageProps";

export const DefaultActivePageStruct: PageTemplateProps = {
  id                            : "",
  name                          : "",
  slug                          : "",
  status                        : "",
  header                        : false,
  footer                        : false,
  fit                           : false,
  private                       : false,
  publish                       : false,
  show_in_search_engines        : false,
  show_in_site_search           : false,
  custom_codes                  : {
    css                 : "",
    start_of_head_tag   : "",
    end_of_head_tag     : "",
    start_of_body_tag   : "",
    end_of_body_tag     : ""
  },
  preview_image                 : "",
  user_type                     : "",
  type                          : PageTypes.HOME,
  meta                          : {
    title               : "",
    description         : "",
    keywords            : ""
  },
  popups                        : [],
  background                    : {
    image               : "",
    size                : "",
    repeat              : "",
    position_vertical   : "",
    position_horizontal : "",
    background_color    : ""
  },
  content                       : []
};